/* 考勤 日历相关接口 */
import { $post } from '@/api/request'

export function query (data = {}) {
  return $post({
    url: '/compCalendar/listByTimeInterval',
    data
  })
}

export function batchUpdate (data = {}) {
  return $post({
    url: '/compCalendar/batchUpdate',
    data
  })
}

export function baseQuery (data = {}) {
  return $post({
    url: '/baseCommonConfig/query',
    data
  })
}

export function baseUpdate (data = {}) {
  return $post({
    url: '/baseCommonConfig/update',
    data
  })
}
export function getThisCompanyConfig (data = {}) {
  return $post({
    url: '/baseCommonConfig/getThisCompanyConfig',
    data
  })
}
export function saveOrUpdate (data = {}) {
  return $post({
    url: '/baseCommonConfig/saveOrUpdate',
    data
  })
}
